import { __ } from '@wordpress/i18n';
import FeatureEmptyState from '../../Common/FeatureEmptyState';

/**
 * Review Alerts Empty State Component
 *
 * Displays when user has no review alerts created.
 * Uses the shared FeatureEmptyState component for consistent layout.
 */
const ReviewAlertsEmptyState = () => {
    const assetsURL = window.sb_customizer?.assetsURL || '';

    return (
        <FeatureEmptyState
            imageUrl={ `${ assetsURL }sb-customizer/assets/images/review-alert-preview.png` }
            imageAlt={ __( 'Review alert preview showing a review', 'reviews-feed' ) }
            title={ __( 'Show review alerts that turn visitors into customers', 'reviews-feed' ) }
            description={ __( 'Animated notifications cycle through your best reviews in the corner of every page — like a live testimonial feed your visitors can\'t miss.', 'reviews-feed' ) }
        />
    );
};

export default ReviewAlertsEmptyState;
